import YatungButton from '@Src/_basic/components/YatungButton';
import EditIcon from '@Src/_basic/icons/Edit';
import { ThirdPartyAccountTableData } from '@Src/_basic/object/ThirdPartyAccountType';
import { Stack } from '@mui/material';
import React from 'react';

export type ExtraData = {
  onGoToUpdatePage: (id: string) => void;
  buttonText: string;
};

interface Props {
  row: ThirdPartyAccountTableData;
  formatExtraData: ExtraData;
}

export default function ActionColumnFormatter(props: Props) {
  const { row, formatExtraData } = props;

  return (
    <Stack spacing={2} direction="row">
      <YatungButton
        text={formatExtraData.buttonText}
        variant={'contained'}
        type={'button'}
        size={'large'}
        startIcon={<EditIcon />}
        onClick={() => {
          formatExtraData.onGoToUpdatePage(row.id);
        }}
        color={'yellow'}
      />
    </Stack>
  );
}
